<template>
  <div>
    <h1>업로드 승인</h1>
    <div>
      <ul>
        <li>
          No.
        </li>
        <li>
          제목
        </li>
        <li>
          개발자
        </li>
        <li>
          신청 일시
        </li>
        <li>
          분류
        </li>
        <li>
          승인
        </li>
        <li>
          확인
        </li>
      </ul>
      <ul>
        <li>
          1
        </li>
        <li>
          lol
        </li>
        <li>
          A
        </li>
        <li>
          19.02.13
        </li>
        <li>
          15
        </li>
        <li>
          <button>승인</button>
        </li>
        <li>
          <button>거절</button>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {

}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/ManageApproval.vue